define([
	"dojo/_base/declare",
	"dojo/dom-class",
	"../SizeChart",
	"./Number"
], function(declare,domClass,SizeChart,NumberRen) {

	return declare(NumberRen, {
		bBaseRenderer: true,
		highlightSetting: "sizeChartHighlightActualOutOfTolerance",

		toHtmlStatic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode, /*ActionData*/actionData) {
			// summary: color red if out of tolerance - make sure to take tolerance format into account
			if (ctx.view.get(this.highlightSetting)) {
				var	value = this._getValue(ctx, h);
				var	bOut = false;

				if (value != this.DEFAULT) {
					var	pattern = this._getPatternWithShrinkage(ctx);
					if (pattern == this.DEFAULT) {
						bOut = true;
					} else {
						var	diff = this._getDiff(value, pattern);
						if (diff) {
							var	scd = ctx.getNodeParent();
							var	tol = scd.Tolerance;

							if (SizeChart.bPct) {
								tol *= pattern;
							} else if (diff < 0) {
								tol = -scd.ToleranceNegative;
							}

							bOut = !this._equal(diff, 0, tol);
						}
					}
				}

				domClass.toggle(refNode, "tableSizeChartActualOut", bOut);
			}

			return this.inherited(arguments);
		},

		_getDiff: function(/*Number*/value, /*Number*/pattern) {
			// summary: return difference between value and pattern
			return value - pattern;
		},

		_getPatternWithShrinkage: function(/*Context*/ctx) {
			// summary: return pattern value for dimension
			return ctx.getNode().PatternWithShrinkage;
		},

		_getValue: function(/*Context*/ctx, /*Heading*/h) {
			// summary: return pattern value if editing default number
			var	value = this.inherited(arguments);

			// lookup actual using old technique
			if ((value == this.DEFAULT) && ctx.keyValue2) {
				value = ctx.getNode()[h.m_id][ctx.keyValue2] || this.DEFAULT;
			}

			return (ctx.dynamicNumber && (value == this.DEFAULT)) ? this._getPatternWithShrinkage(ctx) : value;
		}
	});
});